import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    slider: {
      height: 8,
      marginBottom: '0.4rem',

      '& .MuiSlider-thumb': {
        height: 24,
        width: 24,
        marginTop: -8,
        marginLeft: -12,
        '&:focus, &:hover': {
          boxShadow: 'inherit',
        },
      },

      '& .MuiSlider-valueLabel': {
        left: 'calc(-50% + 1.32rem)',
        top: 'calc(100% + 1rem)',

        '& span': {
          transform: 'none',
        },

        '& > span': {
          margin: '0.2rem 0',
          padding: 0,

          width: 21,
          height: 16,

          background: '#505356',
          border: 'none',
          borderRadius: 5,

          textAlign: 'center',

          '& > span': {
            color: '#FFF',
            fontSize: '1.2rem',
            lineHeight: 1.4,
            fontFamily: theme.typography.body1.fontFamily,
            fontWeight: 600,
          },
        },
      },
      '& .MuiSlider-track': {
        height: 8,
        borderRadius: 4,
      },
      '& .MuiSlider-rail': {
        height: 6,
        borderRadius: 4,
        opacity: 'revert',
        background: '#DAD9D9',
        width: '110%',
        transform: 'translateX(-13px)',
      },
      '& .MuiSlider-mark': {
        transform: 'translateY(100%)',
      },
      '& .MuiSlider-markLabel': {
        margin: '0.4rem 0',
        padding: 0,

        width: 27,
        height: 17,

        background: '#DAD9D9',
        borderRadius: 5,

        textAlign: 'center',

        color: theme.palette.secondary.main,
        fontSize: '1.2rem',
        fontWeight: 600,
        fontFamily: theme.typography.body1.fontFamily,
      },
      '&.Mui-disabled .MuiSlider-markLabel': {
        color: '#A1A19F',
      },
    },
  }),
)
